import { ApplicationInsights } from '@microsoft/applicationinsights-web'

export const initAppInsights = () => {
  const appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: '962e26dd-5e29-47f6-aaf5-4750af44d02d',
      loggingLevelConsole: 2,
      enableAutoRouteTracking: true
    }
  })
  appInsights.loadAppInsights()
  appInsights.trackPageView() // Manually call trackPageView to establish the current user/session/pageview

  // TODO !!! console.error dangerous override !!!
  const originalConsoleErrorFunc = console.error
  console.error = (...args) => {
    originalConsoleErrorFunc(...args)

    appInsights.trackEvent({
      name: 'console.error output',
      properties: { ...args }
    })
  }
}
